import { render, staticRenderFns } from "./AdminTestUsers.vue?vue&type=template&id=449e4375"
import script from "./AdminTestUsers.vue?vue&type=script&lang=ts"
export * from "./AdminTestUsers.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports